import axios from "axios";
import { apiUrl } from "../../App";

export async function getUserFollowingCommunitiesUseCase(userId: string) {
  return await axios.get(`${apiUrl}/users/${userId}/following-communities`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });
}
